import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { Certificate } from './certificate.model';
import {environment} from '../../environments/environment';

@Injectable()
export class RestDataSource {
  constructor(private  http: Http) {

  }

  // Получение данных тестируемого по ИКТ.
  getStudentDataByIkt(stId: number, stIin: string, ttId: number, tYear: number) {
        return this.http.get(`${environment.baseUrl}/grant/test-type/${ttId}/test-year/${tYear}/student/${stId}/iin/${stIin}`)
            .map(response => response.json().data)
            .catch((error: Response) => {
              return Observable.throw(error.json())
            })

  }

  // Виды тестирования
  testTypeCatalog() {
    return this.http.get(`${environment.baseUrl}/catalog/test-type`)
      .map(response => response.json().items)
      .catch((error: Response) => {
        return Observable.throw(error.json())
      })
  }

  testYearCatalog(testType: number) {
    return this.http.get(`${environment.baseUrl}/catalog/test-type/${testType}/year`)
      .map(response => response.json().items)
      .catch((error: Response) => {
        return Observable.throw(error.json())
      })
  }

  certificateSeriesCatalog() {
    return this.http.get(`${environment.baseUrl}/catalog/certificate-series`)
      .map(response => response.json().items)
      .catch((error: Response) => {
        return Observable.throw(error.json())
      })
  }

  getCertificateDownloadLink(testTypeId: number, testYear: number, studentId: string, iin: string) {
    return this.http.get(`${environment.baseUrl}/certificate/grant/download-link/test-type/${testTypeId}/year/${testYear}/student/${studentId}/iin/${iin}`)
      .map(response => response.json().data)
      .catch((error: Response) => {
        return Observable.throw(error.json())
      })
  }
}



// WEBPACK FOOTER //
// C:/Проекты/grant_results/src/app/model/rest.datasource.ts